import { FrontendApplicationContribution } from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import * as monaco from '@theia/monaco-editor-core';

@injectable()
export class MonacoFontMeasurementContribution implements FrontendApplicationContribution {
    async configure(): Promise<void> {
        // Prevent Monaco from caching fallback-font metrics before Geist Mono is available.
        await document.fonts.load('1rem "Geist Mono"');
        monaco.editor.remeasureFonts();
    }
}
